import AccordionDefault from 'components/Sections/Accordion/AccordionDefault';
import AccordionNew from 'components/Sections/Accordion/AccordionNew';
import { ReactNode } from 'react';

type AccordionItemProps = {
  title: object;
  description: object;
  isFirst: boolean;
  presentation?: string;
  children: ReactNode;
};

const AccordionItem = ({
  title,
  presentation = 'default',
  isFirst = true,
  description,
  children,
}: AccordionItemProps) => {
  return (
    <div className="accordion-item">
      {presentation === 'new' && (
        <AccordionNew title={title} description={description} isFirst={isFirst}>
          {children}
        </AccordionNew>
      )}
      {presentation !== 'new' && (
        <AccordionDefault title={title} description={description} isFirst={isFirst}>
          {children}
        </AccordionDefault>
      )}
    </div>
  );
};

export default AccordionItem;
